import React from 'react';
import L from 'leaflet';
import moment from 'moment';
import { Box } from '@material-ui/core';
import { Marker, Popup } from 'react-leaflet';
import globals from '../../../globals/communityGlobals';
import { createCSSSelector } from './cssHelper';

const locale = globals.getArea('dailyPlanning');

const formatHour = date =>
  moment(date)
    .utcOffset(0, true)
    .format(globals.timeFormats.short);

const ClinicianLocationMarker = ({ clinician, isMileageCapEnabled }) => {
  createCSSSelector(`.clinician-color-${clinician.clinicianColor}`, `color:#${clinician.clinicianColor}!important;`);
  const icon = L.divIcon({
    className: `clinician-color-${
      clinician.clinicianColor
    } allocateIcons rag ${clinician.ragStatus.name.toLowerCase()}`,
    iconSize: [30, 48],
    iconAnchor: [23, 48],
    popupAnchor: [0, -55],
    html: 'add_location',
  });
  const { availabilities: timeSlots = [] } = clinician;

  const availabilityTimeSlotFormat = (startDate, endDate) => {
    return startDate === endDate ? formatHour(startDate) : `${formatHour(startDate)} - ${formatHour(endDate)}`;
  };

  const popupContent = (
    <div className="clinician-info">
      {[
        <h5 className="popover-title">{clinician.personName}</h5>,
        timeSlots.map(({ id, actual }) => (
          <div key={`clinicianMarkerPopupTimeSlot${clinician.id + id}`} className="info-timeslot">
            {availabilityTimeSlotFormat(actual.startDate, actual.endDate)}
          </div>
        )),
        <div className="timeslots-info-visits" key={`clinicianMarkerPopupHeader${clinician.id}`}>
          <Box mt={1} display="flex" flexDirection="column">
            <Box mb={0.5}>
              <span className="visits-assigned">
                {locale.getMsg('numberOfAssignedVisits', [clinician.assignedVisitsCount.toString()])}
              </span>
            </Box>
            <Box mb={0.5}>
              <span className="visits-assigned">
                {locale.getMsg('visitsCompleted', [
                  clinician.completedVisitsCount.toString(),
                  clinician.assignedVisitsCount.toString(),
                ])}
              </span>
            </Box>
            <Box mb={0.5}>
              <span>Location: {clinician.clinicianLocation.name}</span>
            </Box>
            <Box>
              <span>Postcode: {clinician.clinicianLocation.postCode}</span>
            </Box>
            {isMileageCapEnabled && (
              <Box>
                <span>Mileage Cap: {clinician.mileageCap}</span>
              </Box>
            )}
          </Box>
        </div>,
      ]}
    </div>
  );

  return (
    <Marker
      payload={<h5 className="popover-title">{clinician.name}</h5>}
      zIndexOffset={1}
      icon={icon}
      position={[clinician.clinicianLocation.latitude, clinician.clinicianLocation.longitude]}
    >
      <Popup>{popupContent}</Popup>
    </Marker>
  );
};

export default ClinicianLocationMarker;
